import { CiCirclePlus } from "react-icons/ci";
import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

interface ChildProps {
  postDiary: (params: FormData) => void;
}

const AddBtn:React.FC<ChildProps> = ({ postDiary }) => {
    const [show, setShow] = useState(false);
    const [title, setTitle] = useState("");
    const [article, setArticle] = useState("");
    const [titleValidation, setTitleValidation] = useState(false);
    const [articleValidation, setArticleValidation] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleAdd = async(event:any) =>{
      event.preventDefault();
        if ( title === ""){
            setTitleValidation(true);
            return;
        }
        if( article === ""){
            setArticleValidation(true);
            return;
        }

        const formData = new FormData();

        formData.append("title", title);
        formData.append("article", article);

        postDiary(formData);

        setTitle("");
        setArticle("");
        setShow(false);
    };

  return (
    <div className='postion-relative'>
      <CiCirclePlus onClick={handleShow} className='position-fixed addbtn'/>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>記事を追加</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <input type="text" className="form-control mb-2" id="exampleFormControlInput1" placeholder="タイトル" value={title} onChange={(e)=>{
            setTitle(e.target.value);
            setTitleValidation(false);
            }}/>
        {titleValidation === true ? <div className="validation text-danger mb-2 ps-1">タイトルが未入力です</div> : "" }
        <textarea className="form-control mb-2 ps-1" id="exampleFormControlTextarea1" rows={5} placeholder="記事の内容" value={article} onChange ={(e)=>{
            setArticle(e.target.value);
            setArticleValidation(false);
            }}></textarea>
        {articleValidation === true ? <div className="validation text-danger mb-2 ps-1">記事が未入力です</div> : "" }
        
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={(e)=>handleAdd(e)}>Post</Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

export default AddBtn